<template>
  <div>
    <a-modal v-model="visible" title="字典类型新增">
      <a-form :form="form">
        <a-form-item
          label="字典值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'dictionaryCode',
              { rules: [{ required: true, message: '请填写字典值' }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="字典名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'dictionaryValue',
              { rules: [{ required: true, message: '请填写字典名称' }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'sortNum',
              { rules: [{ required: true, message: '请填写排序' }] }
            ]"
          ></a-input>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          提交
        </a-button>
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { add } from "@/api/system/dictionary";
export default {
  data() {
    return {
      loading: false,
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 5 }, sm: { span: 24 } },
      wrapperCol: { lg: { span: 17 }, sm: { span: 24 } }
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.loading = true;
      this.form.validateFields((err, values) => {
        if (err) {
          this.loading = false;
        } else {
          add({ ...values }).then(res => {
            this.$emit("ok", res.message);
            this.loading = false;
            this.visible = false;
          });
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form.resetFields();
    }
  }
};
</script>
